import type { AssistantScope } from '@/modules/assistant/services/assistant-scope';

/**
 * The assistant's query keys.
 *
 * ---------------------------------------------------------------------------
 * WHY THE SCOPE IS IN EVERY KEY
 * ---------------------------------------------------------------------------
 * The tenant family and the platform family are different resources with different
 * identifiers: a thread id from one family means nothing in the other. A key that
 * did not carry the scope would let a platform answer be served for a tenant
 * request after a navigation between the two — the cache would return the wrong
 * authority's conversation, and it would look entirely correct.
 *
 * The ROUTE is in the context key for the same reason one level down: the context
 * is a property of the page, and a key without the route would serve the previous
 * page's suggestions after a navigation.
 */
export const assistantQueryKeys = {
  context: (scope: AssistantScope, route: string) =>
    ['assistant', scope, 'context', route] as const,
  threads: (scope: AssistantScope) => ['assistant', scope, 'threads'] as const,
  messages: (scope: AssistantScope, threadId: string) =>
    ['assistant', scope, 'thread', threadId, 'messages'] as const,
};
